import { lazy } from "react";

const DSAPayoutDashboard = lazy(() => import("../Component/DSAPayout/DSAPayoutDashboard"));
const DSAMontlyStatement = lazy(() => import("../Component/DSAPayout/DSAMontlyStatement"));
const DetailDasboardcount = lazy(() => import("../Component/DSAPayout/DetailDashboardcount"));
const ExtendedTeam = lazy(() => import("../Component/DSAPayout/ExtendedTeam"));
const SelfDealDetailView = lazy(() => import("../Component/DSAPayout/SelfDealDetailView"));
const IndividualExtendedTeamMembersDeals = lazy(() =>
  import("../Component/DSAPayout/IndividualExtendedTeamMembersDeals")
);
const ExtendedTeamDetailView = lazy(() => import("../Component/DSAPayout/ExtendedTeamDetailView"));
const DirectTeamDetailView = lazy(() => import("../Component/DSAPayout/DirectTeamDetailView"));
const IndiviualeDirectTeamDetail = lazy(() =>
  import("../Component/DSAPayout/IndiviualeDirectTeamDetail")
);
const MonthlyStatementdocuments = lazy(() =>
  import("../Component/PayoutDocuments/MonthlyStatementdocuments")
);
const BusinessService = lazy(() => import("../Component/BillingPDF/BusinessBilling/BusinessService"));
const PreviousPerformanceMonth = lazy(() =>
  import("../Component/PayoutDocuments/PreviousPerformanceMonth")
);

const dsaRoutes = [
  { path: "/dsa-payout-dashbaord", element: <DSAPayoutDashboard />, protected: true },
  { path: "/dsa-montly-statement", element: <DSAMontlyStatement />, protected: true },
  { path: "/detail-dashboard-count", element: <DetailDasboardcount />, protected: true },
  { path: "/extended-team", element: <ExtendedTeam />, protected: true },
  { path: "/self-deal-detail-view", element: <SelfDealDetailView />, protected: true },
  {
    path: "/indiviual-extended-team-member-detail-view/:id",
    element: <IndividualExtendedTeamMembersDeals />,
    protected: true,
  },
  { path: "/extended-team-detail-view", element: <ExtendedTeamDetailView />, protected: true },
  { path: "/direct-team-detail-view", element: <DirectTeamDetailView />, protected: true },
  {
    path: "/indiviuale-direct-team-detail/:id",
    element: <IndiviualeDirectTeamDetail />,
    protected: true,
  },
  {
    path: "/montly-statement-preview",
    element: <MonthlyStatementdocuments />,
    protected: true,
  },
  { path: "/Business-service-billing", element: <BusinessService />, protected: true },
  { path: "/scale-tracker/detail", element: <PreviousPerformanceMonth />, protected: true },
];

export default dsaRoutes;
